import { MakeCall } from 'ha/services/apiV2/createMakeCall';

interface ListingPhotoUploadRecord {
  url: string;
  contentType: string;
  expires: string;
  photoId: number;
  photoUuid: string;
}

export default (makeCall: MakeCall) => (listingId: number) =>
  makeCall<ListingPhotoUploadRecord>(
    'POST',
    `/api/v2/listing/${listingId}/photos/request`,
  );
